import { createAction, createSlice } from "@reduxjs/toolkit";

export const fetchWorkflowDetailRequest = createAction("workflowDetail/fetchWorkflowDetailRequest");

const initialState = {
  workflow: null,
  loading: false,
  error: null
};

const workflowDetailSlice = createSlice({
  name: "workflowDetail",
  initialState,
  reducers: {
    fetchWorkflowDetailStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchWorkflowDetailSuccess(state, action) {
      state.loading = false;
      state.workflow = action.payload || null;
      state.error = null;
    },
    fetchWorkflowDetailFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearWorkflowDetail(state) {
      state.workflow = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  fetchWorkflowDetailStart,
  fetchWorkflowDetailSuccess,
  fetchWorkflowDetailFailure,
  clearWorkflowDetail
} = workflowDetailSlice.actions;

export default workflowDetailSlice.reducer;
